import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@activar.app/roots-ui/loader';


import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app/app.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideNgxMask } from 'ngx-mask';
import { LocationStrategy, HashLocationStrategy, registerLocaleData } from '@angular/common';
import { ErrorInterceptor } from './app/core/helpers/error.interceptor';
import { JwtInterceptor } from './app/features/auth/helpers/jwt.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import localeEsAr from '@angular/common/locales/es-AR';

registerLocaleData(localeEsAr);


bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule, FullCalendarModule),
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: LOCALE_ID, useValue: 'es-AR' }
    ]
})
  .catch(err => console.error(err));
defineCustomElements(window);